import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [],
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.scss'
})
export class AuthCallbackComponent {
  token: string | null = null;
  processing: boolean = false;
  alreadyHandled = false;
  private queryParamsSubscription: Subscription | undefined;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.processing = true;
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      this.token = params['token'] || null;
       const paymentSuccess = params['paymentSuccess'] === 'true';

      if (this.token) {
        //console.log('Token received in Angular:', this.token);
        localStorage.setItem('access_token', this.token);
        if (this.alreadyHandled) return;
        this.alreadyHandled = true;
        if (paymentSuccess) {
          const userOrderId = localStorage.getItem('userOrderId');
          const restaurantId = localStorage.getItem('restaurantId');

          if (userOrderId && restaurantId) {
            this.router.navigate(['food-order'], {
              queryParams: {
                restaurantId,
                orderId: userOrderId
              }
            });
          } else {
            console.log('Missing orderId or restaurantId');
            this.router.navigate(['/food']);
          }
        }
        else {
          this.router.navigate(['/food']);
        }

        this.processing = false;
      } else {
        console.warn('No token query parameter found in URL.');
        this.processing = false;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }
}
